import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const updateFeedbackStatus = createAsyncThunk(
  "feedback/updateFeedbackStatus",
  async ({ feedbackId, status_sub_identifier }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.patch(`feedback/${feedbackId}/status`, {
        status_sub_identifier,
      });
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const UpdateFeedbackStatusSlice = createSlice({
  name: "UpdateFeedbackStatusSlice",
  initialState: {
    isLoading: false,
    success: false,
    data: null,
    error: null,
  },
  reducers: {
    resetUpdateFeedbackStatus: (state) => {
      state.isLoading = false;
      state.success = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateFeedbackStatus.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateFeedbackStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload?.data;
      })
      .addCase(updateFeedbackStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateFeedbackStatus } = UpdateFeedbackStatusSlice.actions;
export default UpdateFeedbackStatusSlice.reducer;
